import RequireAuth from "../../components/RequireAuth";
import CompanyCardsTable from "./CompanyCardsList";
import {PermissionLevel} from "../../app/api/model/user";
import {Route, Routes} from "react-router-dom";

export default function CompanyCards() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.MANAGER}>
            <Routes>
                <Route index element={<CompanyCardsTable />} />
            </Routes>
        </RequireAuth>
    );
}
